const currenciesUnderRelease: string[] = ['SGD', 'BRL', 'HKD'];

export default currenciesUnderRelease;
